import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  // Normalize language code (e.g. "es-ES", "en-IN" -> "es" / "en") for display and comparison
  const currentLang = (i18n.language || 'es').split('-')[0].toLowerCase();
  const displayLabel = currentLang === 'es' ? 'ES' : 'EN';

  const changeLanguage = (lng) => {
    const lang = lng === 'es' ? 'es' : 'en';
    i18n.changeLanguage(lang);
  };

  const handleLanguageClick = (lng) => () => {
    changeLanguage(lng);
  };

  return (
    <span className="notranslate" translate="no">
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="gap-2"
            aria-label="Select language"
          >
            <Globe className="w-4 h-4" />
            {displayLabel}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="z-[100]" sideOffset={6}>
          <DropdownMenuItem onClick={handleLanguageClick('es')}>
            🇪🇸 Español
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleLanguageClick('en')}>
            🇬🇧 English
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </span>
  );
};

export default LanguageSwitcher;
